import { useCallback, useEffect, useReducer } from 'react';
import { searchMedia } from './search-media';
import { initialState, mediaSearchReducer } from './use-media-search-reducer';
export const useMediaSearch = (axios, query, showAll = true, mediaType) => {
  const [state, dispatch] = useReducer(mediaSearchReducer, initialState);
  useEffect(() => {
    let isSubscribed = true;
    const loadSearchResults = async () => {
      try {
        if (query && (query.searchTerm.length > 0 || showAll)) {
          dispatch({
            type: 'search-start'
          });
          const result = await searchMedia(axios, {
            ...query,
            mediaType: mediaType ?? query.mediaType
          });
          isSubscribed && dispatch({
            type: 'search-success',
            result
          });
        }
      } catch {
        isSubscribed && dispatch({
          type: 'search-failed'
        });
      }
    };
    loadSearchResults();
    return () => {
      isSubscribed = false;
    };
  }, [query, showAll, dispatch, axios, mediaType]);
  useEffect(() => {
    let isSubscribed = true;
    const loadMoreResults = async () => {
      try {
        if (query && state.mediaResult?.next && state.shouldLoadMore) {
          dispatch({
            type: 'load-more-start'
          });
          const result = await searchMedia(axios, {
            ...query,
            next: state.mediaResult.next,
            mediaType: mediaType ?? query.mediaType
          });
          isSubscribed && dispatch({
            type: 'load-more-success',
            result
          });
        }
      } catch {
        isSubscribed && dispatch({
          type: 'load-more-failed'
        });
      }
    };
    loadMoreResults();
    return () => {
      isSubscribed = false;
    };
  }, [axios, query, state.mediaResult, state.shouldLoadMore, mediaType]);
  const loadMore = useCallback(() => dispatch({
    type: 'load-more'
  }), [dispatch]);
  return {
    result: state.mediaResult,
    medias: state.medias,
    isLoading: state.isLoading,
    loadSuccess: state.loadSuccess,
    canLoadMore: state.canLoadMore,
    error: state.loadFailed,
    loadMore
  };
};